module.exports = __webpack_public_path__ + "home-block-7-image-_kZAihh.jpg";